import React from 'react'
import './styles.less';

const ErrorScreen = (props) => <div className="error-wrapper">
    <div className="error-message">
        <h1>Oops.. Something went wrong..</h1>
        <p>Please, reload the page and try later.</p>
    </div>
</div>
export default ErrorScreen;


// WEBPACK FOOTER //
// ./components/Review/ErrorScreen.js